import axios from 'axios';
import * as c from '../../utils/constants';
import { get, filter } from 'lodash';

export const users = (convert = true) =>
  axios
    .post('/api/ds-user', { op: 'list', excludedGroup: 'L0', convert })
    .then((response) => response.data)
    .catch((error) => ({ success: false }));

export const userGet = (id) => (dispatch) =>
  axios
    .post('/api/ds-user', {
      op: 'read',
      convert: true,
      item: {
        id: id,
      },
    })
    .then((response) =>
      axios
        .post('/api/ds-contact-registry', {
          op: 'list',
          convert: true,
          userId: parseInt(id, 10),
        })
        .then((response2) =>
          dispatch({
            type: c.USER_DATA_LOAD,
            payload: {
              ...response.data,
              contacts: filter(
                get(response2, 'data.items', []),
                (u) => !get(u, 'contact.deleted', true)
              ),
            },
          })
        )
        .catch((error) => ({ success: false }))
    );

export const personGet = (id) =>
  axios
    .post('/api/ds-user', {
      op: 'read',
      convert: true,
      item: {
        id: id,
      },
    })
    .then((response) => response.data);

export const createUser = (data) =>
  axios
    .post('/api/ds-user', { op: 'create', item: data })
    .then((response) => ({ data: response.data, success: true }))
    .catch((error) => ({ success: false }));

export const deleteUser = (id) =>
  axios
    .post('/api/ds-user', { op: 'delete', item: { id } })
    .then((response) => ({ data: response.data, success: true }))
    .catch((error) => ({ success: false }));

export const userUpdate = (id, data) =>
  axios
    .post('/api/ds-user', {
      op: 'update',
      item: {
        id,
        ...data,
      },
    })
    .then((response) => ({ data: response.data, success: true }))
    .catch((error) => ({ success: false }));

export const attributeValueGet = (attributeId) =>
  axios
    .post('/api/ds-attribute-value', { op: 'list', attributeId })
    .then((response) => response.data)
    .catch((error) => ({ success: false }));

export const addAttributeUserValue = (userId, attributeValues) =>
  axios
    .post('/api/add-user-attribute-values', { userId: parseInt(userId, 10), attributeValues })
    .then((response) => response.data)
    .catch((error) => ({ success: false }));

export const createAdress = (userId, data) =>
  axios
    .post('/api/ds-address', { op: 'create', item: { ...data, userId } })
    .then((response) => ({ data: response.data, success: true }))
    .catch((error) => ({ success: false }));

export const updateAdress = (data) =>
  axios
    .post('/api/ds-address', { op: 'update', item: data })
    .then((response) => ({ data: response.data, success: true }))
    .catch((error) => ({ success: false }));

export const createIdentity = (userId, data) =>
  axios
    .post('/api/ds-identity-card', { op: 'create', item: { ...data, userId } })
    .then((response) => ({ data: response.data, success: true }))
    .catch((error) => ({ success: false }));

export const updateIdentity = (userId, data) => {
  const id = get(data, 'id', false);
  const op = id ? 'update' : 'create';
  return axios
    .post('/api/ds-identity-card', { op, item: { ...data, userId } })
    .then((response) => ({ data: response.data, success: true }))
    .catch((error) => ({ success: false }));
};

export const createContact = (userId, data) =>
  axios
    .post('/api/add-contact', { userId, ...data })
    .then((response) => ({ data: response.data, success: true }))
    .catch((error) => ({ success: false }));

export const readContact = (userId) =>
  axios
    .post('/api/ds-contact-registry', { userId, op: 'list', convert: true })
    .then((response) => ({ data: response.data, success: true }))
    .catch((error) => ({ success: false }));



// WEBPACK FOOTER //
// ./src/modules/users/_api.js